import React from "react";
import { useTranslation } from "react-i18next";
import CustomSnackbar from "./CustomSnackbar";
import { logging } from "../tools";

function MutationMessage({ mutation, text }) {
  const { t } = useTranslation();

  const getValidation = () => {
    if (mutation.isSuccess) {
      // client offline
      if (mutation.data.data?.resultSentBeep?.failure > 0) {
        return { isError: true, message: t("common.errors.clientOffline") };
      }

      // no status key in obj
      if (!("status" in Object(mutation.data.data))) {
        return {
          isError: true,
          message: t("common.errors.code", {
            code: "status",
          }),
        };
      }

      // version conflict
      if (mutation.data.data?.status === 2) {
        return {
          isError: true,
          message: t("common.errors.versionConflict"),
        };
      }

      // caps error
      if (mutation.data.data?.status === 100) {
        return {
          isError: true,
          message: t("scheduler.errors.tooManyNotis"),
        };
      }

      // unknown error
      if (mutation.data.data?.status <= 0) {
        return {
          isError: true,
          message: t("common.errors.code", {
            code: mutation.data.data?.status,
          }),
        };
      }
      // success
      return {
        isError: false,
        message: text?.success ?? t("common.notifications.done"),
      };
    }

    // user offline
    if (mutation.isError) {
      logging(mutation);
      return {
        isError: true,
        message: t("common.errors.userOffline"),
      };
    }

    return {
      isError: null,
      message: null,
    };
  };
  const validation = getValidation();

  return (
    <React.Fragment>
      {mutation.isLoading ? (
        <CustomSnackbar
          message={text?.loading ?? t("common.notifications.loading")}
          severity="info"
        />
      ) : (
        <React.Fragment>
          {validation.isError !== null ? (
            <CustomSnackbar
              message={validation.message}
              severity={validation.isError ? "error" : "success"}
              autoHideDuration={validation.isError ? null : 3000}
            />
          ) : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default MutationMessage;
